module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    staticClass: "d-dropdown-container",
    class: {
      'd-dropdown-container--active': _vm.isDropDown
    }
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.setDropdownFromClick),
      expression: "setDropdownFromClick"
    }],
    ref: "d_parent",
    staticClass: "d-dropdown__title",
    on: {
      "click": _vm.setDropdown
    }
  }, [_vm._t("title"), _vm._v(" "), (_vm.isShowDots) ? _c('div', {
    staticClass: "d-dropdown__title__circle"
  }, [_vm._t("d-dropdown__icon", function() {
    return [_c('span', {
      staticClass: "icon-more2"
    })]
  })], 2) : _vm._e()], 2), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
    ref: "d_child",
    staticClass: "d-dropdown text-dark",
    class: {
      'd-dropdown--animate': _vm.isPopperReady,
      'd-dropdown--show': _vm.isPopperDone
    },
    attrs: {
      "id": "d-dropdown__d-child"
    }
  }, [_vm._t("list", function() {
    return [_vm._m(0)]
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Rename")]), _vm._v(" "), _c('li', [_vm._v("Help")]), _vm._v(" "), _c('li', {
    staticClass: "d-item-warning"
  }, [_vm._v("Try")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-189acef0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DDropdown.vue
// module id = 1777
// module chunks = 1